module.exports = __webpack_public_path__ + "static/media/right.d8a93a67.png";